var React = require('react');

function StreamlineLine35Picture3 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M15.5 15.5l-3-7.5-2.5 5.5-2.5-3-3 5","key":0}),React.createElement("path",{"d":"M1.5 1.5h17v17h-17z","key":1}),React.createElement("path",{"strokeLinecap":"round","d":"M20.508 7.381l1.992.181L21.137 22.5 6.199 21.137","key":2}),React.createElement("path",{"d":"M1.5 15.5h17","key":3}),React.createElement("circle",{"cx":"6","cy":"6","r":"1.5","key":4})]),React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":1})]);
}

StreamlineLine35Picture3.displayName = "StreamlineLine35Picture3";

StreamlineLine35Picture3.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine35Picture3;

StreamlineLine35Picture3.default = StreamlineLine35Picture3;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-35-picture-3.svg
// module id = 765
// module chunks = 0